import React from 'react';
import Flatpickr from 'react-flatpickr';
import { TextField, InputAdornment } from '@mui/material';
import { CalendarTodayRounded } from '@mui/icons-material';
import 'flatpickr/dist/flatpickr.min.css';
import '../theme/flatpickr-dark.css';

// Shared date input for every date field in the app (per project
// convention — see docs/PLANNING.md). Wraps flatpickr for the calendar
// popup, rendered through an MUI TextField so it still matches the rest
// of the form controls. Value/onChange are plain 'YYYY-MM-DD' strings,
// same format the API expects everywhere.
export default function DateField({ label, value, onChange, size = 'small', sx, maxDate, minDate }) {
    return (
        <Flatpickr
            value={value}
            options={{ dateFormat: 'Y-m-d', maxDate, minDate }}
            onChange={(_, dateStr) => { if (dateStr) onChange(dateStr); }}
            render={(props, ref) => (
                <TextField
                    label={label}
                    size={size}
                    sx={sx}
                    inputRef={ref}
                    defaultValue={props.defaultValue}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <CalendarTodayRounded sx={{ color: 'text.secondary', fontSize: 18 }} />
                            </InputAdornment>
                        ),
                    }}
                />
            )}
        />
    );
}
